<template>

  <div class='dean-form-row'>
    <div class='row input-switch'>
      <div class='small-6 medium-6 large-6 hd-6 columns'>
        <p class='input-label'> {{ label }} </p>
      </div>
      <div class='small-6 medium-6 large-6 hd-6 columns'>
        <dean-input-switch :disabled="disabled" :id="id" @checked="propagateChecked" :checked="value"></dean-input-switch>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
    // VUE
    import { Vue, Component, Prop } from 'vue-property-decorator';
    import vSelect from 'vue-select';
    import deanInputSwitch from './deanInputSwitch.vue'

    // COMPONENTS
    @Component({
        components: {
          vSelect,
			    deanInputSwitch
        },
    })

    export default class deanInputSwitchFormRow extends Vue {
        @Prop() private value?: any;
        @Prop() private placeholder?: string;
        @Prop() private label?: string;
        @Prop() private id?: string;
        @Prop({default: false}) disabled?: boolean;

        public propagateChecked(input: any) {
            this.$emit('checked', input);
        }
    }
</script>

<style lang='scss' scoped>
  p.input-label {
    padding-left: 20px;
  }
</style>

<style lang="scss">
  // IMPORT
  @import '~@deanone/dean-components/src/scss/vars';

  .vs--searchable {
    padding: 5px 10px 5px 10px;
    border-radius: 10px;

    .vs__dropdown-toggle {
      height: 40px;
      background: none;
      background: -webkit-gradient(linear, right top, left top, color-stop(50%, #FFF), color-stop(50%, #f9f9f9));
      background: linear-gradient(to left, #FFF 50%, #f9f9f9 50%);
      background-size: 200% 100%;
      background-position: right bottom;
      border: 1px solid #F5F5F5;
      width: 100%;
      border-radius: 10px;
      -webkit-transition: all ease 0.8s;
      transition: all ease 0.8s;
    }
  }
</style>
